import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faGlobeAmericas,
} from '@fortawesome/free-solid-svg-icons';

function normalizeUrl(url) {
  if (!url) return '';
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}

const UserCard = ({
  user = {},
  extended_user = {},
  settings = false,
  back_home = false,
  view_profile = false,
}) => {
  const {
    first_name = '',
    last_name = '',
    email = '',
    username = '',
  } = user || {};

  const {
    picture_link = '',
    bio = '',
    website = '',
  } = extended_user || {};

  const displayName = (first_name || last_name)
    ? `${first_name} ${last_name}`.trim()
    : username || '';

  return (
    <div>
      {picture_link && (
        <img
          src={picture_link}
          alt={`${displayName} profile`}
          style={{ width: '100%', borderRadius: 8, marginBottom: 12 }}
        />
      )}

      <h3 style={{ fontWeight: 800, fontSize: 20, margin: '0 0 4px' }}>
        {displayName}
      </h3>

      {username && (
        <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 8 }}>
          @{username}
        </div>
      )}

      {bio && (
        <p style={{ fontSize: 13, color: 'var(--ink)', margin: '0 0 8px', lineHeight: 1.4 }}>
          {bio}
        </p>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12 }}>
        {email && (
          <span style={{ fontSize: 12, color: 'var(--muted)', display: 'flex', alignItems: 'center', gap: 6 }}>
            <FontAwesomeIcon icon={faEnvelope} style={{ width: 12, color: 'var(--muted)' }} />
            {email}
          </span>
        )}
        {website && (
          <span style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
            <FontAwesomeIcon icon={faGlobeAmericas} style={{ width: 12, color: 'var(--muted)' }} />
            <a href={normalizeUrl(website)} target="_blank" rel="noopener noreferrer"
              style={{ color: '#59c6c1', textDecoration: 'none' }}>
              {website}
            </a>
          </span>
        )}
      </div>

      {/* Action links */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, fontSize: 13 }}>
        {settings && (
          <Link to="/settings" style={{ color: '#59c6c1', textDecoration: 'none', fontWeight: 600 }}>
            Edit profile
          </Link>
        )}
        {view_profile && username && (
          <Link to={`/${username}`} style={{ color: 'var(--muted)', textDecoration: 'none' }}>
            View public profile
          </Link>
        )}
        {back_home && (
          <Link to="/home" style={{ color: 'var(--muted)', textDecoration: 'none' }}>
            Back to home
          </Link>
        )}
      </div>
    </div>
  );
};

export default UserCard;
